import { render, staticRenderFns } from "./ChangeColorPricing.vue?vue&type=template&id=438199c6&"
import script from "./ChangeColorPricing.vue?vue&type=script&lang=js&"
export * from "./ChangeColorPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports